import React, { useState } from "react";
import { formatWithCommas } from "../../../../helpers/formatWithCommas";

const Summary = ({
  basicInfo,
  saleRounds,
  walletformData,
  nftFormData,
  tokens,
}) => {
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const getSelectedTokensDetails = () => {
    return walletformData.acceptedPaymentTokens
      ?.map((tokenId) => tokens.find((t) => t._id === tokenId))
      .filter(Boolean); // Remove any undefined values
  };

  return (
    <>
      <div className="parentsteps">
        <section className="laststep">
          <div className="inner_laststep">
            <h3>Basic Info</h3>
            <div className="basic_data">
              <div>
                <h4>Project Name</h4>
                <div className="textual_div">
                  <h2>{basicInfo?.projectName?.value}</h2>
                </div>
              </div>
              <div>
                <h4>Project Ticker</h4>
                <div className="textual_div">
                  <h2>${basicInfo?.projectTicker?.value}</h2>
                </div>
              </div>
            </div>
            <h3>Sale Rounds</h3>
            <div className="round_top">
              {saleRounds?.map((item, index) => {
                return (
                  <div key={index} className="rounds_section">
                    <div>
                      <h4>Round</h4>
                      <div className="textual_div">
                        <h2>Round {index + 1}</h2>
                      </div>
                    </div>
                    <div>
                      <h4>Round Price</h4>
                      <div className="textual_div">
                        <h2>{item?.roundPrice}</h2>
                      </div>
                    </div>
                    <div>
                      <h4>Start Date</h4>
                      <div className="textual_div">
                        <h2>{formatDate(item?.startDate)}</h2>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <h3>Wallets & Fees</h3>
            <div className="project_bottom">
              <h4>Project’s Funds Wallet Address</h4>
              <div className="textual_div">
                <h2>{walletformData?.projectFundWallet}</h2>
              </div>
              <h4>Platform Fee Wallet Address</h4>
              <div className="textual_div">
                <h2>{walletformData?.platformFeeWallet}</h2>
              </div>
              <h4>Owner’s Wallet Address</h4>
              <div className="textual_div">
                <h2>{walletformData?.ownerWallet}</h2>
              </div>
                <h4>Lock Wallet Address</h4>
                <div className="textual_div">
                  <h2>{walletformData?.buybackBurnWallet}</h2>
                </div>
              {walletformData?.platformFeeThreshold !== "" && (
                <>
                  <h4>Platform Fee Threshold</h4>
                  <div className="textual_div">
                    <h2>
                      {formatWithCommas(
                        walletformData?.platformFeeThreshold?.toString()
                      )}{" "}
                      <span>$</span>
                    </h2>
                  </div>
                </>
              )}
              {walletformData?.initialPlatformAmount !== "" && (
                <>
                  <h4>Initial Platfrom Amount</h4>
                  <div className="textual_div">
                    <h2>
                      {formatWithCommas(
                        walletformData?.initialPlatformAmount?.toString()
                      )}{" "}
                      <span>$</span>
                    </h2>
                  </div>
                </>
              )}
              <h4>Accepted Payment Tokens</h4>
              <div className="textual_div">
                <div className="top_side_coins">
                  {getSelectedTokensDetails()?.map((item, index) => {
                    return (
                      <div key={index} className="bottom_siddee">
                        <img src={item?.imageUrl} className="imgscoin" />
                        <h6>{item?.tokenSymbol}</h6>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <h3 className="textnftt">NFT & Buyback</h3>
            <div className="nft_main">
              <div className="buyback_main">
                <div className="nft_Sales">
                  <h5>NFT Sale Required </h5>
                  <div
                    className="toggle-container"
                    onClick={() => !nftFormData?.nftRequired} // won't do anything
                    style={{
                      cursor: nftFormData?.nftRequired
                        ? "not-allowed"
                        : "pointer",
                    }}
                  >
                    <div
                      className={`toggle-circle ${
                        nftFormData?.nftRequired ? "active" : ""
                      } ${nftFormData?.nftRequired ? "disabled" : ""}`}
                    ></div>
                  </div>
                </div>
                {nftFormData?.nftRequired && (
                  <div className="nft_Section">
                    <h6>NFT Image</h6>
                    {nftFormData?.nftDetails?.map((item, index) => {
                      return (
                        <div key={index}>
                          <div className="nftimgaes">
                            <img src={item?.image} />
                          </div>
                          <h5>NFT Name</h5>
                          <div className="textual_div">
                            <h2>
                              {basicInfo?.projectName?.value} #00{index}
                            </h2>
                          </div>
                          <h5>NFT Price</h5>
                          <div className="textual_div">
                            <h2>
                              {formatWithCommas(item?.price?.toString())} $
                            </h2>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="nft_Sales lasssttype">
                <h5>Re-buy Required</h5>
                <div
                  className="toggle-container"
                  onClick={() => !nftFormData?.buyBackRequired} // won't do anything
                  style={{
                    cursor: nftFormData?.buyBackRequired
                      ? "not-allowed"
                      : "pointer",
                  }}
                >
                  <div
                    className={`toggle-circle ${
                      nftFormData?.buyBackRequired ? "active" : ""
                    } ${nftFormData?.buyBackRequired ? "disabled" : ""}`}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Summary;
